export class LoadingNotifier {
    show: (name: string, delay?: number) => void = (name: string, delay: number = 0) => { };
    showSaving: (name: string, delay?: number) => void = (name: string, delay: number = 0) => { };
    showSending: (name: string, delay?: number) => void = (name: string, delay: number = 0) => { };
    hide: (name: string) => void = (name: string) => { };
    saveComplate: (name: string) => void = (name: string) => { };
}